<div class="stl-page-wrapper">
  <app-stl-viewer [url]="stlUrl" style="display:block; width:100%; height:100%;"></app-stl-viewer>
  <div class="stl-page-header">
    <mat-icon class="stl-page-icon">view_in_ar</mat-icon>
    <span class="stl-page-filename">{{ fileName }}</span>
  </div>
  <img src="assets/logo.png" class="stl-page-logo" alt="Aliwell">
</div>
